// all constants and utilities function will be define here
export class Utils {
    public static User = JSON.parse(localStorage.getItem('userData'));
    public static SelectedBranch = Utils.User && Utils.User.companyBranchId;
    public static UserBranches = (Utils.User && Utils.User.userBranchs) ? Utils.User.userBranchs : [];
}
